module.exports = __webpack_public_path__ + "static/media/galerija_2019 (35).71acf72a.jpg";